<div class="spinner">
    <ng-content></ng-content>
</div>
